import React from 'react';
import * as style from '../Hooks/style';
import Conditional from "../Hooks/ConditionalRender";
//Images
import db_mobile from "../Images/s3_db_mobile.png";
import db_bg from '../Images/dashboard/db_bg.png';
import db_person from '../Images/dashboard/db_person.png';
import db_center1 from '../Images/dashboard/db_center1.png';
import db_left1 from '../Images/dashboard/db_left1.png';
import db_left2 from '../Images/dashboard/db_left2.png';
import db_left3 from '../Images/dashboard/db_left3.png';
import db_left4 from '../Images/dashboard/db_left4.png';
import db_right1 from '../Images/dashboard/db_right1.png';
import db_right2 from '../Images/dashboard/db_right2.png';
import db_right3 from '../Images/dashboard/db_right3.png';

export const Sect3 = ({fref, active3}) => {
  return (
    <style.Section3 ref={fref}>
      <Conditional if={active3 === true}>
        <img src={db_mobile} className="s3-dashboard-mobile" alt="dashboard" />
        <section className="s3-dashboard">
          <img className="db_bg" src={db_bg} alt="db_bg" />
          <img className="db_person" src={db_person} alt="db_person" />
          <img className="db_center1" src={db_center1} alt="db_center1" />
          <span className='db_center1overlay' />
          <img className="db_left1" src={db_left1} alt="db_left1" />
          <img className="db_left2" src={db_left2} alt="db_left2" />
          <img className="db_left3" src={db_left3} alt="db_left3" />
          <img className="db_left4" src={db_left4} alt="db_left4" />
          <img className="db_right1" src={db_right1} alt="db_right1" />
          <img className="db_right2" src={db_right2} alt="db_right2" />
          <img className="db_right3" src={db_right3} alt="db_right3" />
        </section>
        <h2>Why MarinaX?</h2>
        <section>
          <h4>Maritime Suite</h4>
          <p>Dedicated technology customized for only maritime suite.</p>
        </section>
        <section>
          <h4>Our Aim</h4>
          <p>To keep your technology simple, robust and rich.</p>
        </section>
      </Conditional>
    </style.Section3>
  );
}